import { Theme } from '@mui/material'

const useStyles = {
  background: (theme: Theme, isMobile: boolean) => ({
    minHeight: '100dvh',
    alignItems: isMobile ? 'stretch' : 'center',
    justifyContent: 'center',
    padding: isMobile ? 0 : 3,
    backgroundColor: theme.palette.ui.surfaceContainerHigh,
  }),
  card: (theme: Theme, isMobile: boolean, hasGradient: boolean) => ({
    flexDirection: 'column' as const,
    width: '100%',
    maxWidth: isMobile ? 'none' : 758,
    minHeight: isMobile ? '100dvh' : 0,
    borderRadius: isMobile ? 0 : 3.5,
    background: hasGradient ? 'linear-gradient(159deg, #D0E7FF 12.03%, #F8FDFF 88.04%)' : theme.palette.ui.surfaceContainer,
  }),
  header: (theme: Theme) => ({
    minHeight: 92,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    borderBottom: `0.5px solid ${theme.palette.ui.outlineVariant}`,
  }),
  backHeader: (theme: Theme) => ({
    minHeight: 64,
    alignItems: 'center',
    flexWrap: 'nowrap',
    gap: 1,
    paddingX: 1,
    flexShrink: 0,
    borderBottom: `0.5px solid ${theme.palette.ui.outlineVariant}`,
  }),
  content: {
    flex: 1,
    flexDirection: 'column' as const,
    minHeight: 0,
  },
}

export default useStyles
